import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/catch';
import { UserHazardModel } from '../Models/UserHazardModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResultModel } from '../Models/ResultModel';

@Injectable()
export class UserHazardService {
  apiURL: string = "";

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    //this.apiURL = baseUrl + 'api/UserHazard/';
    if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
      this.apiURL = sessionStorage.getItem("BaseURL") || '';
      this.apiURL = this.apiURL + 'api/UserHazard';
    }
  }

  SaveHazardMaster(TokenKey: string, uHazard: UserHazardModel[]): Observable<number> {
    let fullAPIPath = this.apiURL + '/AddUserHazard';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this.http.post<number>(fullAPIPath, uHazard, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private extractData(res: Response) {
    let body = res.json();
    return body;
  }

  private handleError(error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.status)
  }
}
